import gButtonColor from "glesys-controlpanel/helpers/g-button-color";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import IconsConsole from "../icons/console";
import { t } from "ember-intl";

const isNotCompact = (display) => display !== "compact";

<template>
  <div
    class="inline-flex rounded-sm text-sm px-4 py-2 mt-6 mb-2 {{gButtonColor 'outline'}}"
    {{mergeClasses}}
    ...attributes
  >
    <a
      class="flex items-center text-gray-800"
      aria-label={{if @ariaLabel @ariaLabel (t "component.console.default-aria-label")}}
      href={{@href}}
      target="_blank"
      rel="noopener noreferrer"
    >
      <IconsConsole class="w-4 mr-2 {{if (isNotCompact @display) '-ml-1'}} -mt-px text-rebeccapurple-700" />
      <span>
        {{yield}}
      </span>
    </a>
  </div>
</template>
